import { themeAtom } from "../../shared/atoms";
import { useAtomValue } from "jotai";
import { useState } from "react";
import { twMerge } from "tailwind-merge";

type TabsProps = {
  children: React.ReactElement<any>[];
};

const Tabs = ({ children }: TabsProps) => {
  const theme = useAtomValue(themeAtom);

  const [activeTab, setActiveTab] = useState(children[0].props.label);

  const handleClick = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>, newActiveTab: string) => {
    e.preventDefault();
    setActiveTab(newActiveTab);
  };

  return (
    <div className="mx-auto">
      <div className={twMerge("justify-between border-b-[1px]", theme.myVesselsTable.tailwind.tableBorder)}>
        {children.map((child) => (
          <button
            key={child.props.label}
            className={`${activeTab === child.props.label ? "border-b-2 border-green text-green" : ""} flex-1 py-2 pl-2 pr-2 text-sm font-medium ${theme.home.tailwind.textDefault}`}
            onClick={(e) => handleClick(e, child.props.label)}
          >
            {child.props.label}
          </button>
        ))}
      </div>
      <div className="py-4">
        {children.map((child) => {
          if (child.props.label === activeTab) {
            return <div key={child.props.label}>{child.props.children}</div>;
          }
          return null;
        })}
      </div>
    </div>
  );
};

type TabProps = {
  label: string;
  children: React.ReactElement<any>;
};

const Tab = ({ label, children }: TabProps) => {
  return (
    <div
      // @ts-expect-error
      label={label}
      className="hidden text-sm"
    >
      {children}
    </div>
  );
};
export { Tab, Tabs };
